import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PrlLoginPageComponent} from './components/prl-login-page/prl-login-page.component';
import {unauthorizedGuard} from '../../shared/services/unauthorized-guard.guard';
import {prlAuthentificationGuard} from '../../shared/services/prl-authentification-guard';
import {PrlContactUsPageComponent} from './components/prl-contact-us-page/prl-contact-us-page.component';
import {
    PrlTermsAndConditionsPageComponent
} from './components/prl-terms-and-conditions-page/prl-terms-and-conditions-page.component';
import {
    PrlPortalNotificationPageComponent
} from './components/prl-portal-notification-page/prl-portal-notification-page.component';
import {PrlRegistrationPageComponent} from './components/prl-registration-page/prl-registration-page.component';
import {PrlChangePasswordComponent} from './components/prl-change-password/prl-change-password.component';
import {
    PrlExternalResetPasswordComponent
} from './components/prl-external-reset-password/prl-external-reset-password.component';
import {PrlUnsubscribeComponent} from './components/prl-unsubscribe/prl-unsubscribe.component';
import {PrlPageGuard} from '../../shared/services/prl-page.guard';

const routes: Routes = [
    {
        path: 'login',
        canActivate: [unauthorizedGuard, PrlPageGuard],
        component: PrlLoginPageComponent,
        data: {pageName: 'Login Page'}
    },
    {
        path: 'login/activate/:username/:hash',
        canActivate: [unauthorizedGuard, PrlPageGuard],
        component: PrlLoginPageComponent,
        data: {pageName: 'Login Page'}
    },
    {
        path: 'contact-us',
        canActivate: [unauthorizedGuard, PrlPageGuard],
        component: PrlContactUsPageComponent,
        data: {
            className: 'com.playtech.mexos.contract.portal.ContactUsObj',
            pageName: 'Contact Us Page'
        }
    },
    {
        path: 'external-reset-password',
        canActivate: [unauthorizedGuard],
        component: PrlExternalResetPasswordComponent
    },
    {
        path: 'external-registration',
        canActivate: [unauthorizedGuard],
        component: PrlRegistrationPageComponent,
        data: {
            className: 'com.playtech.mexos.contract.affiliate.PortalNewAffiliateObj',
            restLink: '/signup/register'
        }
    },
    {
        path: 'portal-notifications',
        canActivate: [prlAuthentificationGuard],
        component: PrlPortalNotificationPageComponent
    },
    {
        path: 'registration',
        canActivate: [unauthorizedGuard, PrlPageGuard],
        component: PrlRegistrationPageComponent,
        data: {
            className: 'com.playtech.mexos.contract.affiliate.PortalNewAffiliateObj',
            restLink: '/signup/register',
            pageName: 'Signup Page',
            title: 'label.menu.signup'
        }
    },
    {
        path: 'force-reset-password',
        canActivate: [prlAuthentificationGuard],
        component: PrlChangePasswordComponent
    },
    {
        path: 'reset-password/:token',
        component: PrlChangePasswordComponent
    },
    {
        path: 'terms',
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        component: PrlTermsAndConditionsPageComponent,
        data: {pageName: 'Terms and Conditions Page'}
    },
    {
        path: 'unsubscribe',
        canActivate: [unauthorizedGuard],
        component: PrlUnsubscribeComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PrlAuthenticationRoutingModule {
}
